/**
 * CSRF トークン読み取りユーティリティ
 *
 * 【CSRF とは？】
 * Cross-Site Request Forgery（クロスサイトリクエストフォージェリ）。
 * 別のサイトから「なりすまし」リクエストを送られる攻撃。
 * Cookie 認証（Web）の場合のみ対策が必要。
 *
 * 【仕組み（Double Submit Cookie）】
 * 1. サーバーが csrf_token を Cookie に設定する
 *    - この Cookie は HttpOnly=false（JS から読み取れる）
 *    - アクセストークンの Cookie は HttpOnly=true（JS から読み取れない）
 * 2. フロントが Cookie から csrf_token を読み取る（この関数）
 * 3. フロントが POST/PUT/DELETE リクエスト時に X-CSRF-Token ヘッダに付与
 *    （baseQuery.ts の prepareHeaders で自動的に行う）
 * 4. サーバーが Cookie の値とヘッダの値を比較 → 一致すれば正規リクエスト
 *
 * 【なぜこれで安全？】
 * - 悪意のあるサイトは「別ドメインの Cookie を JS で読み取ること」ができない
 * - だから X-CSRF-Token ヘッダに正しい値を付けられない
 * - サーバーは「Cookie の値 ≠ ヘッダの値」を検知して拒否する
 */

/**
 * Cookie から csrf_token の値を読み取る。
 *
 * document.cookie は "key1=value1; key2=value2; ..." という文字列を返す。
 * 正規表現で csrf_token=xxx の部分を抽出する。
 *
 * @returns csrf_token の値。Cookie が存在しない場合は null。
 */
export function getCsrfTokenFromCookie(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
